
import React from "react";

const AnimatedOrb = () => {
  return (
    <div className="absolute -z-10 top-0 right-0 h-64 w-64 bg-gradient-to-br from-fuchsia-200 to-violet-300 rounded-full opacity-30 blur-3xl animate-float"></div>
  );
};

export default AnimatedOrb;
